import script from "./menuComp.vue?vue&type=script&setup=true&lang=js"
export * from "./menuComp.vue?vue&type=script&setup=true&lang=js"

import "./menuComp.vue?vue&type=style&index=0&id=38241742&lang=scss&scoped=true"
import "./menuComp.vue?vue&type=style&index=1&id=38241742&lang=scss"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38241742"]])

export default __exports__